import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React, { Component } from 'react';
import View from "react-native-web/dist/exports/View";
import PropTypes from 'prop-types';
import XDate from 'xdate';
import dateutils from "../dateutils";
import { xdateToData, parseDate } from "../interface";
import { SELECT_DATE_SLOT } from "../testIDs";
import styleConstructor from "./style";
import Day from "../calendar/day/basic";
import UnitDay from "../calendar/day/period";
import MultiDotDay from "../calendar/day/multi-dot";
import MultiPeriodDay from "../calendar/day/multi-period";
import SingleDay from "../calendar/day/custom";
import Calendar from "../calendar";
import { jsx as ___EmotionJSX } from "@emotion/core";
var EmptyArray = [];

var Week = function (_Component) {
  _inherits(Week, _Component);

  var _super = _createSuper(Week);

  function Week(props) {
    var _this;

    _classCallCheck(this, Week);

    _this = _super.call(this, props);
    _this.style = styleConstructor(props.theme);
    return _this;
  }

  _createClass(Week, [{
    key: "getWeek",
    value: function getWeek(date) {
      if (date) {
        var current = parseDate(date);
        var daysArray = [current];
        var dayOfTheWeek = current.getDay() - this.props.firstDay;

        if (dayOfTheWeek < 0) {
          dayOfTheWeek = 7 + dayOfTheWeek;
        }

        var newDate = current;
        var index = dayOfTheWeek - 1;

        while (index >= 0) {
          newDate = parseDate(newDate).addDays(-1);
          daysArray.unshift(newDate);
          index -= 1;
        }

        newDate = current;
        index = dayOfTheWeek + 1;

        while (index < 7) {
          newDate = parseDate(newDate).addDays(1);
          daysArray.push(newDate);
          index += 1;
        }

        return daysArray;
      }
    }
  }, {
    key: "getDayComponent",
    value: function getDayComponent() {
      var dayComponent = this.props.dayComponent;

      if (dayComponent) {
        return dayComponent;
      }

      switch (this.props.markingType) {
        case 'period':
          return UnitDay;

        case 'multi-dot':
          return MultiDotDay;

        case 'multi-period':
          return MultiPeriodDay;

        case 'custom':
          return SingleDay;

        default:
          return Day;
      }
    }
  }, {
    key: "getDateMarking",
    value: function getDateMarking(day) {
      var markedDates = this.props.markedDates;

      if (!markedDates) {
        return false;
      }

      var dates = markedDates[day.toString('yyyy-MM-dd')] || EmptyArray;

      if (dates.length || dates) {
        return dates;
      } else {
        return false;
      }
    }
  }, {
    key: "renderDay",
    value: function renderDay(day, id) {
      var current = this.props.current;
      var minDate = parseDate(this.props.minDate);
      var maxDate = parseDate(this.props.maxDate);
      var state = '';

      if (this.props.disabledByDefault) {
        state = 'disabled';
      } else if (minDate && !dateutils.isGTE(day, minDate) || maxDate && !dateutils.isLTE(day, maxDate)) {
        state = 'disabled';
      } else if (!dateutils.sameMonth(day, parseDate(current))) {
        state = 'disabled';
      } else if (dateutils.sameDate(day, XDate())) {
        state = 'today';
      }

      if (current && this.props.hideExtraDays) {
        if (!dateutils.sameMonth(day, parseDate(current))) {
          return ___EmotionJSX(View, {
            key: id,
            style: {
              flex: 1
            }
          });
        }
      }

      var DayComp = this.getDayComponent();
      var dayDate = day.getDate();
      var dateAsObject = xdateToData(day);
      return ___EmotionJSX(View, {
        style: {
          flex: 1,
          alignItems: 'center'
        },
        key: id
      }, ___EmotionJSX(DayComp, {
        testID: SELECT_DATE_SLOT + "-" + dateAsObject.dateString,
        state: state,
        theme: this.props.theme,
        onPress: this.props.onDayPress,
        onLongPress: this.props.onDayPress,
        date: dateAsObject,
        marking: this.getDateMarking(day)
      }, dayDate));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var current = this.props.current;
      var dates = this.getWeek(current);
      var week = [];

      if (dates) {
        dates.forEach(function (day, id) {
          week.push(_this2.renderDay(day, id));
        }, this);
      }

      return ___EmotionJSX(View, {
        style: this.style.container
      }, ___EmotionJSX(View, {
        style: [this.style.week, this.props.style]
      }, week));
    }
  }]);

  return Week;
}(Component);

_defineProperty(Week, "displayName", 'IGNORE');

_defineProperty(Week, "propTypes", _objectSpread({}, Calendar.propTypes, {
  current: PropTypes.any
}));

export default Week;

if (typeof Week !== 'undefined' && Week && Week === Object(Week) && Object.isExtensible(Week) && !Week.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Week, '__filemeta', {
    configurable: true,
    value: {
      name: "Week",
      filename: "node_modules/react-native-calendars/src/expandableCalendar/week.js"
    }
  });
}